import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs/operators';
import { EcomSettingService } from './ecom-services/ecom-setting.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  // constructor to inject the class objects
  constructor(private titleService: Title,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private settingService: EcomSettingService) {

    this.settingService.currentUserInfo.subscribe(user => {

      let lang = "en";
      if (user && user.selectedLanguage) {
        lang = user.selectedLanguage;
      }
      translate.setDefaultLang(lang);
      translate.use(lang);
      console.log("lang", lang);
    });

  }

  // component initialize and load the required data
  ngOnInit() {
    const appTitle = this.titleService.getTitle();
    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child.firstChild) {
            child = child.firstChild;
          }
          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
          return appTitle;
        })
      ).subscribe((title: string) => {
        this.titleService.setTitle('OLAR - ' + title);
      });
  }
}
